var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";

import styles from "./About.css";

var Mission = function (_Component) {
  _inherits(Mission, _Component);

  function Mission() {
    _classCallCheck(this, Mission);

    return _possibleConstructorReturn(this, (Mission.__proto__ || Object.getPrototypeOf(Mission)).apply(this, arguments));
  }

  _createClass(Mission, [{
    key: "render",
    value: function render() {
      return React.createElement(
        "div",
        { className: styles.aboutSections },
        React.createElement(
          "div",
          { className: styles.sectionHeaders },
          React.createElement(
            "h4",
            null,
            "Our mission"
          )
        ),
        React.createElement(
          "div",
          { className: styles.aboutContent },
          React.createElement(
            "p",
            null,
            "We are a new media company delivering vital, trustworthy news and analysis in the most efficient, illuminating and shareable ways possible. We offer a mix of original and smartly narrated coverage of media trends, tech, business and politics with expertise, voice AND smart brevity \u2014 on a new and innovative mobile platform. At Axios \u2014 the Greek word for worthy \u2014 we provide only content worthy of people\u2019s time, attention and trust."
          )
        )
      );
    }
  }]);

  return Mission;
}(Component);

export default Mission;


// WEBPACK FOOTER //
// ./src/about/components/About/Mission.js